import ProdTravelHeader from "./Header";
import "./index.css";
import ProdTravelContents from "./Transport";
import { ShowHide } from "../components/ShowHideProduct";
import FlowNumbersBox from "../components/FlowNumbersBox";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const ProdTravelComponents = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="prod-travel-container" id="prod-travel-id">
      <ProdTravelHeader productId={productId} show={show} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />

        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox
            isNormal={true}
            number={"Flow 14"}
            color={"#193666"}
          />
        </div>
      </div>
      <ShowHide show={show} setShow={setShow} />
      {show && <ProdTravelContents productId={productId} />}
    </div>
  );
};

export default ProdTravelComponents;
